import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
    render() {
        return (
            (window.location.href.includes("/login") || window.location.href.includes("/register")) ?
                <div>
                    <Container>
                        {this.props.children}
                    </Container>
                </div>
                :
                <div>
                    <NavMenu />
                    <Container>
                        {this.props.children}
                    </Container>
                </div>
        );
    }
}